// entry point for the WebApp
require("./output/WebApp/index.js").main();
